import React from 'react';
import { browserHistory } from 'react-router';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import VocabularyThemeListFilterContainer from './VocabularyThemeListFilterContainer';
import VocabularyThemeListContainer from './VocabularyThemeListContainer';

const VocabularyThemeListScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Vocabulary Themes',
        },
      ]}
    />
    <Card
      title="Vocabulary Themes"
      actions={
        <Button
          type="primary"
          label="New vocabulary Theme"
          icon="plus"
          onClick={() => browserHistory.push('/vocabulary-themes/new')}
        />
      }
    >
      <VocabularyThemeListFilterContainer />
      <VocabularyThemeListContainer />
    </Card>
  </div>
);

export default VocabularyThemeListScene;
